import {action} from 'typesafe-actions'
import {DraftPeople} from '@models/draftPeople'
import {RequestData} from "@models/axios";
import {CommentsActionTypes} from "./comment";


export const enum DraftsPeopleActionTypes {
    FETCH_REQUEST = '@@draftsPeople/FETCH_REQUEST',
    FETCH_SUCCESS = '@@draftsPeople/FETCH_SUCCESS',
    FETCH_ERROR = '@@draftsPeople/FETCH_ERROR',

    UPDATE_REQUEST = '@@draftsPeople/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@draftsPeople/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@draftsPeople/UPDATE_ERROR',
}


export const fetchRequest = (data: RequestData) => action(DraftsPeopleActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: DraftPeople[]) => action(DraftsPeopleActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(DraftsPeopleActionTypes.FETCH_ERROR, message);

export const updateRequest = (data: RequestData) => action(DraftsPeopleActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: RequestData) => action(DraftsPeopleActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(DraftsPeopleActionTypes.UPDATE_ERROR, message);

